import request from '@/utils/request'
const BASE_URL = '/PrGetDocTask'

export default {
  list(data) {
    return request({
      url: BASE_URL + '/List',
      method: 'post',
      data
    })
  },
  info(id) {
    return request({
      url: BASE_URL + '/Info',
      method: 'get',
      params: { id }
    })
  },
  infos(data) {
    return request({
      url: BASE_URL + '/Infos',
      method: 'post',
      data
    })
  },
  save(data) {
    return request({
      url: BASE_URL + '/Save',
      method: 'post',
      data
    })
  },
  examine(id) {
    return request({
      url: BASE_URL + '/Examine',
      method: 'get',
      params: { id }
    })
  },
  cancelExamine(id) {
    return request({
      url: BASE_URL + '/CancelExamine',
      method: 'get',
      params: { id }
    })
  },
  delete(ids) {
    return request({
      url: BASE_URL + '/Delete',
      method: 'post',
      params: { ids }
    })
  },
  surplusMaterialList(data) {
    return request({
      url: BASE_URL + '/SurplusMaterialList',
      method: 'post',
      data
    })
  },
  workDocSummary(data) {
    return request({
      url: BASE_URL + '/WorkDocSummary',
      method: 'post',
      data
    })
  },
  delete(data) {
    return request({
      url: BASE_URL + '/Delete',
      method: 'post',
      data
    })
  },
  updateStatus(data) {
    return request({
      url: BASE_URL + '/UpdateStatus',
      method: 'post',
      data
    })
  },
  export(data){
    return request({
      url: BASE_URL + '/Export',
      method: 'post',
      responseType: 'blob',
      data
    }).then(res => {

      var file = res.data;
      console.log('res', res, res.data)
      var disposition = res.headers['content-disposition'];
      // console.log('disposition', disposition);

      var fileName = "导出";
      if (disposition.lastIndexOf("filename*=UTF-8''") != -1) {
        var text = disposition.substr(disposition.lastIndexOf("filename*=UTF-8''") + ("filename*=UTF-8''").length)
        fileName = decodeURI(text);
      }

      if (navigator.msSaveBlob) {
        // IE10+下载
        navigator.msSaveBlob(file, fileName);
      } else {
        const elink = document.createElement("a");
        elink.download = fileName;
        elink.style.display = "none";
        elink.target = "_blank";
        elink.href = URL.createObjectURL(file);
        document.body.appendChild(elink);
        elink.click();
        URL.revokeObjectURL(elink.href); // 释放URL 对象
        document.body.removeChild(elink);
      }
      return Promise.resolve();
    
    }).catch(err => {
      console.log(err)
    })
  }
}
